import { TOrientation } from "../../../types/form-element-types";
import InputElementTopSection from "../components/input-element-top-section/input-element-top-section";
import styles from "./radio-button-group.module.less";

type TRadioButton = {
  id: string;
  name?: string;
  value: string;
  label?: string | React.ReactNode;
  isChecked?: boolean;
  isDisabled?: boolean;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
};

const RadioButton = ({ id, value, name, label, isChecked, isDisabled, onChange }: TRadioButton) => {
  return (
    <div className={styles.inputLabelWrapper}>
      <input
        className={styles.input}
        id={id}
        type="radio"
        name={name}
        value={value}
        checked={isChecked}
        disabled={isDisabled}
        onChange={onChange}
      />
      <label htmlFor={id} className={[styles.radioLabel, isChecked ? styles.checked : ""].join(" ")} key={id}>
        <div className={[styles.radioButton, isChecked ? styles.checked : ""].join(" ")} />
        {label && <span className={styles.radioText}>{label}</span>}
      </label>
    </div>
  );
};

export type TRadioButtonProps = {
  id: string;
  value: string;
  label?: string | React.ReactNode;
  isDisabled?: boolean;
};

export type TRadioButtonGroupProps = {
  label?: string | React.ReactNode;
  radioButtons: Array<TRadioButtonProps>;
  name: string;
  value?: string | null;
  helperText?: string;
  errorText?: string;
  isDisabled?: boolean;
  orientation?: TOrientation;
  onChange?: (name: string, value: string) => void;
  onChangeNative?: (event: React.ChangeEvent<HTMLInputElement>) => void;
};

export const RadioButtonGroup = ({
  label,
  radioButtons,
  name,
  value,
  isDisabled,
  helperText,
  errorText,
  orientation = "horizontal",
  onChange,
  onChangeNative,
}: TRadioButtonGroupProps) => {
  const onChangeLocal = (event: React.ChangeEvent<HTMLInputElement>) => {
    const name = event.target.name;
    const newValue = event.target.value;

    if (typeof onChange === "function") {
      onChange(name, newValue);
    }

    if (typeof onChangeNative === "function") {
      onChangeNative(event);
    }
  };

  return (
    <fieldset className={styles.wrapper}>
      <InputElementTopSection legend={label} helperText={helperText} errorText={errorText} />
      <div className={[styles.radioWrapper, styles[orientation], errorText ? styles.error : ""].join(" ")}>
        {radioButtons.map((radioButton) => {
          const checked = value === radioButton.value;
          const disabled = isDisabled || radioButton.isDisabled;
          return (
            <RadioButton
              key={radioButton.id}
              {...radioButton}
              onChange={onChangeLocal}
              name={name}
              isChecked={checked}
              isDisabled={disabled}
            />
          );
        })}
      </div>
    </fieldset>
  );
};

export default RadioButtonGroup;
